import uploadTypes from 'shared/constants/upload-types';


const UPLOAD_TYPE_TO_BI_NAME_MAP = {
  [uploadTypes.BUTTON_CLICK]: 'upload',
  [uploadTypes.DRAG_AND_DROP]: 'drag&drop',
};


export default function (uploadType) {
  if (!uploadTypes.hasOwnProperty(uploadType)) {
    uploadType = uploadTypes.BUTTON_CLICK;
  }

  return UPLOAD_TYPE_TO_BI_NAME_MAP[uploadType];
}



// WEBPACK FOOTER //
// ./src/shared/utils/bi/get-bi-upload-type.js